import { render, staticRenderFns } from "./VecdynCollectionsByDateChart.vue?vue&type=template&id=ead61ae6&"
import script from "./VecdynCollectionsByDateChart.vue?vue&type=script&lang=js&"
export * from "./VecdynCollectionsByDateChart.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports